/**
 *  @class
 *  @function MediaWithTabs
 */
if (!customElements.get('media-with-tabs')) {
  class MediaWithTabs extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.media-with-tabs--tab'));
      this.slider = this.querySelector('slide-show');
      this.tabClickHandlers = [];
      this.tabs.forEach((tab, i) => {
        let handler = () => this.tabClick(tab, i);
        this.tabClickHandlers.push({ tab, handler });
        tab.addEventListener('click', handler);
      });

      this.onBlockSelectBound = (e) => {
        let tab = e.target.closest('.media-with-tabs--tab');
        if (tab) {
          let index = this.tabs.indexOf(tab);
          if (index > -1) {
            this.tabClick(tab, index);
          }
        }
      };
      this.addEventListener('shopify:block:select', this.onBlockSelectBound);

      this.querySelectorAll('.media-with-tabs--media--controls button').forEach((toggle) => {
        toggle.addEventListener('click', (e) => {
          e.stopPropagation();
          let video = toggle.closest('.media-with-tabs--media--video').querySelector('video');
          if (video.paused) {
            video.play();
            toggle.classList.remove('paused');
          } else {
            video.pause();
            toggle.classList.add('paused');
          }
        });
      });
    }
    disconnectedCallback() {
      if (this.tabClickHandlers) {
        this.tabClickHandlers.forEach(({ tab, handler }) => {
          tab.removeEventListener('click', handler);
        });
      }
      if (this.onBlockSelectBound) {
        this.removeEventListener('shopify:block:select', this.onBlockSelectBound);
      }
    }
    tabClick(tab, i) {
      let flkty = Flickity.data(this.slider);
      this.tabs.forEach((el) => {
        el.classList.remove('active');
      });
      tab.classList.add('active');

      flkty.select(i);
    }
  }
  customElements.define('media-with-tabs', MediaWithTabs);
}